module.exports = __webpack_public_path__ + "img/socialise-org.cb3d3ac8.jpg";